"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const displayUser_1 = __importDefault(require("./displayUser"));
exports.default = (userOrVendor, session) => {
    var _a;
    const displayText = displayUser_1.default(userOrVendor);
    const { vendorToken, organizationId, id } = userOrVendor;
    const isSysAdmin = ((_a = session === null || session === void 0 ? void 0 : session.availableProfiles) === null || _a === void 0 ? void 0 : _a.find(p => p.role == 'SYS_ADMIN')) || session.user.sysadminId;
    if (vendorToken && isSysAdmin) {
        return (react_1.default.createElement("div", null,
            react_1.default.createElement("a", { href: `/web/organization/switchToOrg?organization=${organizationId}&backUrl=${encodeURIComponent(window.location.pathname + window.location.search)}` }, displayText)));
    }
    if (isSysAdmin) {
        return (react_1.default.createElement("div", null,
            react_1.default.createElement("a", { href: `/web/user/switchToUser?user=${id}&backUrl=${encodeURIComponent(window.location.pathname + window.location.search)}` }, displayText)));
    }
    return react_1.default.createElement("div", null, displayText);
};
//# sourceMappingURL=displayUserWithLoginLink.js.map